/**
 * Detect Internet Explorer 11
 */
export function isIE11() {
	return !!(window as any).MSInputMethodContext && !!(document as any).documentMode;
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/util/browserDetect.ts